import { render, staticRenderFns } from "./OButton.vue?vue&type=template&id=52057daa&scoped=true&"
import script from "./OButton.vue?vue&type=script&lang=js&"
export * from "./OButton.vue?vue&type=script&lang=js&"
import style0 from "./OButton.vue?vue&type=style&index=0&id=52057daa&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52057daa",
  null
  
)

export default component.exports